var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3C2.94772 3 2.5 3.44772 2.5 4V20C2.5 20.5523 2.94771 21 3.5 21H20.5C21.0523 21 21.5 20.5523 21.5 20V16.75H17C14.3766 16.75 12.25 14.6233 12.25 12C12.25 9.37664 14.3766 7.24999 17 7.24999H21.5V4C21.5 3.44772 21.0523 3 20.5 3H3.5ZM21.5 8.74999H17C15.2051 8.74999 13.75 10.2051 13.75 12C13.75 13.7949 15.2051 15.25 17 15.25H21.5V8.74999ZM6 7.99999H9.88868V6.49999H6V7.99999ZM18.3186 12.0272C18.3186 12.5763 17.8833 13.0215 17.3464 13.0215C16.8095 13.0215 16.3743 12.5763 16.3743 12.0272C16.3743 11.478 16.8095 11.0328 17.3464 11.0328C17.8833 11.0328 18.3186 11.478 18.3186 12.0272Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.07f2671e63b2ff5d111f032cd7bd546e.svg";
export { ForwardRef as ReactComponent };